import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ButtonModule } from '@openng/optimus-ui/button';
import { IconComponent } from '@padspin/ui-marketing-icons';

@Component({
  selector: 'padspin-marketing-landlord-hero',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, RouterLink, ButtonModule, IconComponent],
  template: `
    <section class="relative overflow-hidden bg-gradient-soft">
      <div
        class="pointer-events-none absolute -top-32 -right-32 h-96 w-96 rounded-full bg-gradient-brand opacity-20 blur-3xl"
      ></div>
      <div
        class="pointer-events-none absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-gradient-brand opacity-20 blur-3xl"
      ></div>

      <div
        class="mx-auto grid max-w-7xl items-center gap-12 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:px-8 lg:py-28"
      >
        <div class="animate-fade-up">
          <div
            class="inline-flex items-center gap-2 rounded-full border border-surface bg-surface-50/70 dark:bg-surface-950/70 px-4 py-1.5 text-xs font-medium text-color backdrop-blur"
          >
            <padspin-icon
              name="sparkles"
              [size]="14"
              class="text-brand-green-700"
            />
            AI-Powered Home &amp; Apartment Leasing
          </div>
          <h1
            class="mt-6 text-5xl font-bold tracking-tight text-color sm:text-6xl lg:text-7xl"
          >
            Rent your unit in
            <span class="text-gradient-brand">just days.</span>
          </h1>
          <p class="mt-6 max-w-xl text-lg text-muted-color sm:text-xl">
            No vacancies. No brokers. No nonsense. Padspin matches landlords
            with highly qualified renters in 72 hours — for a flat $800.
          </p>
          <div class="mt-8 flex flex-wrap items-center gap-3">
            <a pButton size="large" routerLink="/post-pad">
              Post Your Pad
              <padspin-icon name="arrow-right" [size]="16" />
            </a>
            <a
              routerLink="/rent"
              class="inline-flex h-12 items-center justify-center rounded-xl border border-surface bg-surface-50/60 dark:bg-surface-950/60 px-8 text-base font-semibold text-color backdrop-blur transition-smooth hover:bg-surface-50/80"
            >
              I'm a Renter
            </a>
          </div>
          <div class="mt-10 grid grid-cols-3 gap-6">
            <div>
              <padspin-icon
                name="clock"
                [size]="20"
                class="text-brand-blue-700"
              />
              <div class="mt-2 text-2xl font-bold text-color">72h</div>
              <div class="text-xs text-muted-color">Avg. lease time</div>
            </div>
            <div>
              <padspin-icon
                name="shield-check"
                [size]="20"
                class="text-brand-blue-700"
              />
              <div class="mt-2 text-2xl font-bold text-color">700+</div>
              <div class="text-xs text-muted-color">Min. credit score</div>
            </div>
            <div>
              <padspin-icon
                name="sparkles"
                [size]="20"
                class="text-brand-blue-700"
              />
              <div class="mt-2 text-2xl font-bold text-color">$800</div>
              <div class="text-xs text-muted-color">Flat fee, period</div>
            </div>
          </div>
        </div>

        <div class="relative animate-fade-up">
          <div class="relative overflow-hidden rounded-3xl shadow-glow">
            <img
              ngSrc="/assets/ui-marketing-landlord-page/hero-apartment.jpg"
              alt="Bright, modern apartment interior leased through Padspin"
              width="1600"
              height="1200"
              priority
              class="h-full w-full object-cover"
            />
            <div
              class="absolute inset-0 bg-gradient-to-tr from-brand-blue-500/10 via-transparent to-brand-green-500/10"
            ></div>
          </div>
          <div
            class="absolute -bottom-6 -left-6 hidden rounded-2xl border border-surface bg-surface-0/95 dark:bg-surface-900/95 p-4 shadow-card backdrop-blur sm:block"
          >
            <div class="flex items-center gap-3">
              <img
                src="/assets/ui-marketing-landlord-page/padspin-door.svg"
                alt=""
                width="40"
                height="40"
                class="h-10 w-10 animate-float-slow"
              />
              <div>
                <div class="text-xs font-medium text-muted-color">
                  Just leased
                </div>
                <div class="text-sm font-semibold text-color">
                  2BR · Williamsburg, NYC
                </div>
              </div>
            </div>
          </div>
          <div
            class="absolute -top-4 -right-4 hidden rounded-2xl bg-gradient-brand px-4 py-3 text-primary-contrast shadow-glow sm:block"
          >
            <div class="text-xs opacity-90">AI Match Score</div>
            <div class="text-2xl font-bold">98%</div>
          </div>
        </div>
      </div>
    </section>
  `,
})
export class MarketingLandlordHeroComponent {}
